var map = {
	"./1544923318981": 40,
	"./1544923318981.jpg": 40,
	"./credits_logo": 41,
	"./credits_logo.png": 41,
	"./credits_logo_2x_large": 42,
	"./credits_logo_2x_large.png": 42,
	"./credits_logo_large": 43,
	"./credits_logo_large.png": 43,
	"./credits_panama_logo": 44,
	"./credits_panama_logo.jpg": 44,
	"./favicon/favicon": 45,
	"./favicon/favicon.png": 45,
	"./logo": 46,
	"./logo.png": 46,
	"./persona-login": 47,
	"./persona-login.png": 47,
	"./rolando-signature": 48,
	"./rolando-signature.jpeg": 48,
	"./signature": 49,
	"./signature.png": 49,
	"./signatures/douglas_zuleta": 50,
	"./signatures/douglas_zuleta.jpeg": 50,
	"./signatures/edelmira_lopez": 51,
	"./signatures/edelmira_lopez.png": 51,
	"./signatures/edgar_derek": 52,
	"./signatures/edgar_derek.png": 52,
	"./signatures/maria_alejandra_estrada_arauz": 53,
	"./signatures/maria_alejandra_estrada_arauz.png": 53,
	"./signatures/maria_mendieta": 54,
	"./signatures/maria_mendieta.png": 54,
	"./yappy-logo": 55,
	"./yappy-logo.png": 55
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 346;